import { TableNoData } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { TabPanel } from '@mui/lab';
import { Box } from '@mui/material';
import { memo } from 'react';
import { useNotificationStore } from '../../store';
import { NotificationDetail } from '../notification-detail';
import * as SX from './sx';
import type { NotificationTabProps as Props } from './types';

export const NotificationPanel = memo(
  ({ className, value, items, ...other }: Props) => {
    const noData = !items?.length;
    const notificationConfig = useNotificationStore.useNotificationConfig();

    return (
      <TabPanel
        className={classnames('NotificationPanel', className)}
        value={value}
        sx={SX.tabPanel}
        {...other}
      >
        {noData ? (
          <Box sx={SX.dataNotFoundWrapper}>
            <TableNoData
              isError={false}
              config={{
                emptyIcon: 'bell',
                iconSize: 24,
                title: `You're all caught up!`,
                emptyIconWrapperSX: SX.emptyIconWrapperSX,
              }}
            />
          </Box>
        ) : (
          items.map((item) => (
            <NotificationDetail
              key={item.id}
              item={item}
              {...notificationConfig?.(item)}
            />
          ))
        )}
      </TabPanel>
    );
  }
);

NotificationPanel.displayName = 'NotificationPanel';
